import { Button, Circle, Text, VStack } from "@chakra-ui/react";
import { PersonCircleIcon } from "modules/icons";
import { useUsers } from "modules/providers/users-provider";
import React, { memo, useCallback, useMemo } from "react";
import colors from "app/colors";
import {
  DRAWER_TYPE,
  useOverlay,
} from "modules/providers/overlay-provider/overlay-provider";
import { isUserInteractive } from "modules/utils/Functions";

interface IProps {
  userId: string;
}

const ViewUserProfileButton = ({ userId }: IProps) => {
  const { openDrawer } = useOverlay();
  const { usersById } = useUsers();

  const user = useMemo(() => usersById[userId], [userId, usersById]);

  const onViewUserProfileClicked = useCallback(
    (userId: string) => () => {
      openDrawer({
        type: DRAWER_TYPE.USER_PROFILE,
        id: userId,
      });
    },
    [openDrawer],
  );

  if (!isUserInteractive(user)) {
    return null;
  }

  return (
    <Button
      aria-label="View Profile"
      onClick={onViewUserProfileClicked(userId)}
      variant="hover"
      height="auto"
      px={0}
    >
      <VStack spacing={1}>
        <Circle bg={colors.gray40} size={6}>
          <PersonCircleIcon boxSize={4} fill={colors.white} />
        </Circle>
        <Text
          fontSize={10}
          color={colors.gray50}
          textAlign="center"
          lineHeight="10px"
        >
          View
          <br />
          Profile
        </Text>
      </VStack>
    </Button>
  );
};

export default memo(ViewUserProfileButton);
